// src/context/authApi.js
import { api } from "./api";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // 1-step: telefon raqamga kod yuborish
    sendCode: builder.mutation({
      query: ({ phone }) => ({
        url: "/auth/send-code",
        method: "POST",
        body: { phone },
      }),
    }),

    // 2-step: kodni tekshirish (verify-page ishlatadi)
    verifyCode: builder.mutation({
      query: ({ phone, code }) => ({
        url: "/auth/verify-code",
        method: "POST",
        body: { phone, code },
      }),
    }),

    // 3-step: parol + profil
    completeRegistration: builder.mutation({
      query: ({ phone, password, name, email }) => ({
        url: "/auth/complete-registration",
        method: "POST",
        body: { phone, password, name, email },
      }),
      invalidatesTags: ["User"],
    }),

    // login
    login: builder.mutation({
      query: ({ phone, password }) => ({
        url: "/auth/login", // backendda /api/auth/login bo‘ladi
        method: "POST",
        body: { phone, password },
      }),
      invalidatesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSendCodeMutation,
  useVerifyCodeMutation,
  useCompleteRegistrationMutation,
  useLoginMutation,
} = authApi;
